import React from "react";
import ThirdApp from "@/components/ThirdApp";

export default function ThirdAppPage() {
  return <ThirdApp />;
}
